import { createFileRoute } from "@tanstack/react-router";

import { AgencyPackagePage } from "@/components/agency-package-page";

// Private QR-only landing page: noindex and not in the sitemap.
const AGENCY = "Reid & Co.";

export const Route = createFileRoute("/reid-co")({
  head: () => ({
    meta: [
      { title: `${AGENCY} sellers | AML and Form 2 package | Coastside Law` },
      {
        name: "description",
        content: `AML identity checks and a solicitor-prepared Form 2 for ${AGENCY} sellers: $799 all inclusive, paid at settlement.`,
      },
      { property: "og:title", content: `${AGENCY} sellers | Coastside Law` },
      { property: "og:description", content: "One AML check, a solicitor-prepared Form 2, one fixed price." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <AgencyPackagePage agency={AGENCY} />,
});
